import type { SelectOptionType } from '~/presentation/reports/ui/type';

import { TARGET_CHANNEL, TARGET_DEVICES, TARGET_VISITOR } from '~/constants/campaign';
import { EReportDataType } from '~/presentation/reports/common/Visualization/types';
import { AnalyticInterval } from '~/modules/analytics/types';
import { IVariantType } from '~/modules/campaign/types';

export const TIME_OPTIONS = [
  {
    label: 'Hour',
    value: AnalyticInterval.HOUR.toLocaleLowerCase(),
    dataType: EReportDataType.HOUR,
  },
  {
    label: 'Day',
    value: AnalyticInterval.DAY.toLocaleLowerCase(),
    dataType: EReportDataType.DAY,
  },
  {
    label: 'Week',
    value: AnalyticInterval.WEEK.toLocaleLowerCase(),
    dataType: EReportDataType.WEEK,
  },
  {
    label: 'Month',
    value: AnalyticInterval.MONTH.toLocaleLowerCase(),
    dataType: EReportDataType.MONTH,
  },
  {
    label: 'Quarter',
    value: AnalyticInterval.QUARTER.toLocaleLowerCase(),
    dataType: EReportDataType.QUARTER,
  },
  {
    label: 'Year',
    value: AnalyticInterval.YEAR.toLocaleLowerCase(),
    dataType: EReportDataType.YEAR,
  },
];

export const TIME_KEYS = new Set(TIME_OPTIONS.map((opt) => opt.value));

export const DEVICE_OPTIONS = TARGET_DEVICES;

export const VISITOR_OPTIONS = TARGET_VISITOR;

export const TRAFFIC_SOURCE_OPTIONS = TARGET_CHANNEL;

export const VERSION_LABEL = {
  [IVariantType.VARIANT_A]: 'Control A',
  [IVariantType.VARIANT_B]: 'Variant B',
};
export const VERSION_OPTIONS = [
  { label: VERSION_LABEL[IVariantType.VARIANT_A], value: IVariantType.VARIANT_A },
  { label: VERSION_LABEL[IVariantType.VARIANT_B], value: IVariantType.VARIANT_B },
];

export const OPERATOR_IS = 'is';
export const OPERATOR_IS_ONE_OF = 'is_one_of';
export const SINGLE_VALUE_OPERATOR_OPTIONS = [
  { label: 'is', value: OPERATOR_IS, desc: 'Matches exactly one value' },
];

export const MULTIPLE_VALUE_OPERATOR_OPTIONS = [
  { label: 'is one of', value: OPERATOR_IS_ONE_OF, desc: 'Matches any of the values' },
];

export const OPERATOR_OPTIONS = [
  ...SINGLE_VALUE_OPERATOR_OPTIONS,
  ...MULTIPLE_VALUE_OPERATOR_OPTIONS,
];

export const REPORT_FILTER_WIDTH = '248px';

const buildChartLabelMap = (groups: SelectOptionType[][]) => {
  const map: Record<string, string> = {};

  groups.flat().forEach(({ value, label }) => {
    map[value] = label;
  });

  return map;
};

export const CHART_LABEL_MAP = buildChartLabelMap([
  DEVICE_OPTIONS,
  VISITOR_OPTIONS,
  TRAFFIC_SOURCE_OPTIONS,
  VERSION_OPTIONS,
]);
